const createValidator = (testFn: (value: string) => boolean) => {
  return (value: string, required = true) => {
    if (!value) {
      return !required;
    }
    return testFn(value);
  };
};

// verify it's a number with decimal places
export const decimalValidator = createValidator((number) =>
  /^\d+(\.\d+)?$/.test(number),
);
